import {
  productionLoadLabel,
  type MfgProductionLoad,
} from "@/lib/manufacturing/productionLoadsClient";
import {
  ghostBtnClass,
  inputClass,
  mfgPrimaryBtnClass,
} from "@/components/manufacturing/manufacturingSurfaceClasses";

export function BuildPipelineLoadsStrip({
  loads,
  busy,
  aliasDraft,
  onAliasDraft,
  footageDraft,
  onFootageDraft,
  onCreate,
  onDispatch,
  onClose,
}: {
  loads: MfgProductionLoad[];
  busy: boolean;
  aliasDraft: string;
  onAliasDraft: (v: string) => void;
  footageDraft: string;
  onFootageDraft: (v: string) => void;
  onCreate: () => void;
  onDispatch: (loadId: string) => void;
  onClose: (loadId: string) => void;
}) {
  const open = loads.filter((l) => l.status === "open");
  const dispatched = loads.filter((l) => l.status === "dispatched");

  return (
    <div className="mb-4 space-y-3 rounded-lg border border-gray-200 bg-white px-3 py-3 dark:border-zinc-700 dark:bg-zinc-900">
      <div className="flex flex-wrap items-end gap-2">
        <label className="text-sm text-gray-700 dark:text-zinc-300">
          New load alias
          <input
            className={`${inputClass} mt-1 block`}
            value={aliasDraft}
            onChange={(e) => onAliasDraft(e.target.value)}
            placeholder="Optional (e.g. Friday run)"
            disabled={busy}
          />
        </label>
        <label className="text-sm text-gray-700 dark:text-zinc-300">
          Footage notes
          <input
            className={`${inputClass} mt-1 block`}
            value={footageDraft}
            onChange={(e) => onFootageDraft(e.target.value)}
            placeholder="Ops footage (freeform)"
            disabled={busy}
          />
        </label>
        <button type="button" className={mfgPrimaryBtnClass} disabled={busy} onClick={onCreate}>
          New load
        </button>
      </div>
      {open.length === 0 && dispatched.length === 0 ? (
        <p className="text-xs text-gray-500">No open loads. Create one, then assign units from the card drawer.</p>
      ) : (
        <ul className="flex flex-wrap gap-2">
          {open.map((load) => (
            <li
              key={load.id}
              className="flex items-center gap-2 rounded-md border border-indigo-200 bg-indigo-50 px-2 py-1 text-xs dark:border-indigo-800 dark:bg-indigo-950/40"
            >
              <span className="font-mono font-semibold text-indigo-900 dark:text-indigo-100">
                {productionLoadLabel(load)}
              </span>
              <span className="text-indigo-700 dark:text-indigo-300">{load.unit_count} units</span>
              <button
                type="button"
                className={ghostBtnClass}
                disabled={busy || load.unit_count === 0}
                onClick={() => onDispatch(load.id)}
              >
                Send to plant
              </button>
            </li>
          ))}
          {dispatched.map((load) => (
            <li
              key={load.id}
              className="flex items-center gap-2 rounded-md border border-gray-200 px-2 py-1 text-xs dark:border-zinc-700"
            >
              <span className="font-mono text-gray-700 dark:text-zinc-200">
                {productionLoadLabel(load)} · dispatched
              </span>
              <button type="button" className={ghostBtnClass} disabled={busy} onClick={() => onClose(load.id)}>
                Close (free letter)
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
